jQuery(document).ready(function() {
	console.log("test header");

		// Fix search popdown input label
		jQuery('#predictive-search-input-search-popdown').attr("aria-label","Search our store");
		jQuery('label[for="predictive-search-input-search-popdown"]').text("Search our store");

		jQuery('.header__backfill__content img').attr("alt","");
		jQuery('.notify-pn-bk-stock-input-email').attr("aria-label","Email");
		jQuery('.ll__discount-code-input.ll__input').attr("aria-label","Enter discount code");
		jQuery('.ll__apply-discount-button.ll__button').attr("aria-label","Apply discount code");
		jQuery('.ll__select-button').attr("aria-label","Select reward option");
		jQuery('.ll__close-button').attr("aria-label","Close");
		jQuery('.ll__create-account-button.ll__button').attr("aria-label","Create account");
		jQuery('.ll__copy-discount-button.ll__copy-button').attr("aria-label","Copy discount code");
		jQuery('.Shopify-link a').attr("aria-label","Shopify website, opens in new tab");

		// Fix navigation links missing accessible names
		jQuery('.navlink--child, .navlink--grandchild').each(function() {
			var linkText = jQuery(this).find('.navtext').text().trim();
			if (linkText && !jQuery(this).attr('aria-label')) {
				jQuery(this).attr('aria-label', linkText);
			}
		});

		// Fix popout list options missing accessible names
		jQuery('.popout-list__option').each(function() {
			var optionText = jQuery(this).find('span').text().trim() || jQuery(this).text().trim();
			if (optionText && !jQuery(this).attr('aria-label')) {
				jQuery(this).attr('aria-label', optionText);
			}
		});

		// Fix decorative SVG icons - ensure they are hidden from assistive tech
		jQuery('.icon-theme, .icon-social, .svg-loader').each(function() {
			jQuery(this).attr('aria-hidden', 'true');
			jQuery(this).attr('focusable', 'false');
			jQuery(this).attr('role', 'presentation');
		});

        jQuery('.absolute.top-0.right-0.bottom-0.left-0.overflow-hidden.flex.flex-col.justify-end').removeAttr("aria-labelledby");
        jQuery('.link-over-image').attr("aria-label","Exclusive Facebook Group doop fragrance co, Join Now,  opens facebook in new tab");

		jQuery('.announcement h3').attr("role","none");

        jQuery('.menu__item.parent').removeAttr("role");
        jQuery('.menu__item.parent').removeAttr("aria-haspopup");
        jQuery('.menu__item.parent').removeAttr("aria-expanded");

		jQuery('.inline-flex.items-center.transition-opacity.duration-500.ease-linear').attr("role","region");
		jQuery('.inline-flex.items-center.transition-opacity.duration-500.ease-linear').attr("aria-label","announcement bar");
		jQuery('.shopify-section-group-group-footer').attr("role","contentinfo");

		jQuery('.instagram-grid-container').attr("role","button");
		jQuery('.instagram-grid-container').attr("tabindex","0");
		jQuery('.footer__icon.footer__icon--social').attr("aria-label","doop fragrance co instagram page, opens in new tab");
		
        jQuery('.instagram-grid-item').attr("role","button");

		// Focus management for drawers/modals - prevent focus from going to elements underneath
		// Use MutationObserver to detect when drawers become visible
		var mainContent = document.querySelector('main') || document.querySelector('#MainContent') || document.querySelector('.main-content');

		function setInertOnBackground(isOpen) {
			if (mainContent) {
				if (isOpen) {
					mainContent.setAttribute('inert', '');
				} else {
					mainContent.removeAttribute('inert');
				}
			}
		}

		// Watch for drawer visibility changes
		var drawers = document.querySelectorAll('.drawer, [data-drawer]');
		drawers.forEach(function(drawer) {
			var observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.attributeName === 'class') {
						// Only set inert if drawer is actually visible (has is-visible class)
						if (drawer.classList.contains('is-visible') || drawer.classList.contains('drawer--visible')) {
							setInertOnBackground(true);
						} else {
							setInertOnBackground(false);
						}
					}
				});
			});
			observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
		});

		// Also listen for custom drawer events
		document.addEventListener('theme:drawer:open', function() {
			setInertOnBackground(true);
		});
		document.addEventListener('theme:drawer:close', function() {
			setInertOnBackground(false);
		});

    setTimeout(function(){
      //your code
    jQuery('.absolute.top-0.right-0.bottom-0.left-0.overflow-hidden.flex.flex-col.justify-end').removeAttr("aria-labelledby");
        jQuery('.instagram-grid-item').attr("role","button");
        jQuery('.instagram-grid-item').attr("tabindex","0");
        jQuery('#PBarNextFrame').attr("title","preview bar");
        // Re-apply loyalty app button fixes for late-loading elements
        jQuery('.ll__close-button').attr("aria-label","Close");
        jQuery('.ll__create-account-button.ll__button').attr("aria-label","Create account");
        jQuery('.ll__copy-discount-button.ll__copy-button').attr("aria-label","Copy discount code");
        // Re-apply search popdown label fix
        jQuery('#predictive-search-input-search-popdown').attr("aria-label","Search our store");
        jQuery('label[for="predictive-search-input-search-popdown"]').text("Search our store");

        // Re-apply navigation link fixes for late-loading elements
        jQuery('.navlink--child, .navlink--grandchild').each(function() {
			var linkText = jQuery(this).find('.navtext').text().trim();
			if (linkText && !jQuery(this).attr('aria-label')) {
				jQuery(this).attr('aria-label', linkText);
			}
		});

		// Re-apply popout list option fixes
		jQuery('.popout-list__option').each(function() {
			var optionText = jQuery(this).find('span').text().trim() || jQuery(this).text().trim();
			if (optionText && !jQuery(this).attr('aria-label')) {
				jQuery(this).attr('aria-label', optionText);
			}
		});

		// Re-apply SVG icon accessibility fixes
		jQuery('.icon-theme, .icon-social, .svg-loader').each(function() {
			jQuery(this).attr('aria-hidden', 'true');
			jQuery(this).attr('focusable', 'false');
			jQuery(this).attr('role', 'presentation');
		});

     },
  3000); 

    setTimeout(function(){ 
      //your code

        jQuery('#PBarNextFrameWrapper iframe').attr("title","preview bar");

        
     },
  5000); 



  



   });